import { Component, OnInit, Input, HostListener, ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { SuccessDialogComponent } from 'src/app/modules/dialogs/success_dialog/success_dialog.component';
import { DataService } from 'src/app/modules/new-dashboard/pages/data-service';
import { SellersService } from 'src/app/service/seller/sellers.service';

@Component({
  selector: 'navbar-dashboard',
  templateUrl: './navbar-dashboard.component.html',
  styleUrls: ['./navbar-dashboard.component.scss']
})
export class NavbarDashboardComponent implements OnInit {

  isCollapsed = false;
  isFirstMenuVisible = true;
  isSecondMenuVisible = false;

  flag_dashboard_comercial:boolean = false;
  flag_dashboard_operative:boolean = false;
  flag_dashboard_environment:boolean = false;
  flag_dashboard_monitoring:boolean = false;
  flag_dashboard_project_detail:boolean = false;
  flag_dashboard_asset_map:boolean = false;
  flag_dashboard_target_net_zero:boolean = false;
  flag_dashboard_download:boolean = false;
  flag_client_selected:boolean = false;
  clientSelected;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _authService: AuthService,
    private dataService: DataService,
    private change: ChangeDetectorRef,
    private _sellerService: SellersService, 
    private dialog: MatDialog
  ) {
  }

  ngOnInit(): void {
    if (!localStorage.getItem('sidebarCollapsed')) {
      this.isCollapsed = false;
    }
    else {
      this.isCollapsed = localStorage.getItem('sidebarCollapsed') === 'true';
    }
    this.active_pages();

    this._sellerService.client$.subscribe(flag =>{
        this.flag_client_selected = flag;
        if (this.flag_client_selected) {
            this.clientSelected = JSON.parse(localStorage.getItem('seller')).name;
        }
    })

    this.onResize(window);
  }

  updateMatMenuBackground() {
    const isDarkMode = document.documentElement.classList.contains('dark');
    const menuPanel = document.querySelector('.mat-menu-panel') as HTMLElement;

    if (menuPanel) {
      if (isDarkMode) {
        menuPanel.style.setProperty('background', '#0E151D');
      } else {
        menuPanel.style.setProperty('background', '#FFFFFF');
      }
    }
  }

  clear_select() {
    localStorage.removeItem('seller');

    const dialogRef = this.dialog.open(SuccessDialogComponent, {
      autoFocus: false,
      panelClass: 'no-padding-dialog',
      data: {
        title: 'Selección eliminada',
        content: 'Selección eliminada correctamente.',
        buttons: [{ label: 'Aceptar', action: 'ok' }]
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      this._sellerService.change_flag_select_client(false);
      this.clientSelected = false;
      this.dataService.validation_load = false;
      this.dataService.comercial_load = false;
      location.reload();
      this.ngOnChanges();
    });
  }

  change_client(){
    this.router.navigate(['/dashboard-profile'])
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (window.innerWidth <= 768) {
      this.isFirstMenuVisible = false;
      this.isSecondMenuVisible = true;

      this.isCollapsed = false;
      localStorage.setItem('sidebarCollapsed', this.isCollapsed.toString());
      window.dispatchEvent(new Event('storage'));

    } else {
      this.isFirstMenuVisible = true;
      this.isSecondMenuVisible = false;
    }
  }

  isActive(route: string): boolean {
    return this.router.url === route;
  }

  navigate(route: string): void {
    if (!this.isActive(route)) {
      this.router.navigate([route]);
    }
  }

  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
    localStorage.setItem('sidebarCollapsed', this.isCollapsed.toString());
    window.dispatchEvent(new Event('storage'));
  }

  active_pages() {
    let permissions = this._authService.allowed_pages;
    permissions.forEach(element => {
      switch (element) {
        case 'dashboard-comercial':
          this.flag_dashboard_comercial = true;
          break;
        case 'dashboard-operative':
          this.flag_dashboard_operative = true;
          break;
        case 'dashboard-environment':
          this.flag_dashboard_environment = true;
          break;
        case 'dashboard-monitoring':
          this.flag_dashboard_monitoring = true;
          break;
        case 'dashboard-project-detail':
          this.flag_dashboard_project_detail = true;
          break;
        case 'dashboard-asset-map':
          this.flag_dashboard_asset_map = true;
          break;
        case 'dashboard-target-net-zero':
            this.flag_dashboard_target_net_zero = true;
            break;
        case 'dashboard-download':
            this.flag_dashboard_download = true;
            break;

        case 'all':
          this.flag_dashboard_comercial = true;
          this.flag_dashboard_operative = true;
          this.flag_dashboard_environment = true;
          this.flag_dashboard_monitoring = true;
          this.flag_dashboard_project_detail = true;
          this.flag_dashboard_asset_map = true;
          this.flag_dashboard_target_net_zero = true;
          this.flag_dashboard_download = true;
          break;

        default:
          break;
      }
    });

  }

  ngOnChanges(){
    this.change.detectChanges();
    this.ngOnInit();
}

  logout() {
    // Limpiar cookies
    document.cookie.split(";").forEach(function(c) {
        document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
    this.dataService.ClearDataService()
    // Limpiar almacenamiento local
    localStorage.clear()
    this._sellerService.change_flag_select_client(false);
    // Limpiar almacenamiento de sesión
    sessionStorage.clear()

    this._authService.signOut()

    // Redirigir a la página de inicio de sesión
    this.router.navigate(['/login'])
  }

}
